import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PATRIMOINE_COLLECTIVITES } from '../../../../config/patrimoine-collectivites';

export default function MairiesPage() {
  const parcours = PATRIMOINE_COLLECTIVITES.find((p) => p.slug === 'mairies');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="collectivites"
      segment="patrimoine"
      segmentLabel="Patrimoine"
    />
  );
}
